import { useState, useEffect } from 'react';

export function useDebounce<T>(value: T, delay: number): T {
  const [debouncedValue, setDebouncedValue] = useState<T>(value);

  useEffect(() => {
    // Thiết lập một timeout để thay đổi giá trị sau khi chờ delay
    const timeout = setTimeout(() => {
      setDebouncedValue(value);
    }, delay);

    // Xóa timeout cũ nếu giá trị thay đổi hoặc component bị unmount
    return () => {
      clearTimeout(timeout);
    };
  }, [value, delay]);

  return debouncedValue;
}